module.exports = __webpack_public_path__ + "images/crossthumb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossthumb.png
// module id = GIuF
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13